<template>
  <div class="has-border-b filters white">
    <transition name="fade">
      <div v-if="filtersContainer">
        <div class="filters-title">
          <v-icon color="gray-6">filter_list</v-icon>
          {{ $t('Common.filters') }}
        </div>

        <div class="filters-item filters-item--search filters-item--reset">
          <v-text-field
            v-if="!isReportRides"
            v-model="filters.search"
            :placeholder="searchPlaceholder"
            prepend-inner-icon="search"
            :disabled="!isSuccess"
            :loading="searchIsLoading"
            color="accent"
            height="36"
            flat
            solo
            clearable
            hide-details
            @input="handleSearch"
          />
        </div>

        <div class="filters-item">
          <MenuItemPeriod
            :status="status"
            @change="updateFilters"
            @changePeriod="changePeriod"
          />
        </div>

        <div
          v-show="claims.costCenter['ROLE_GET_COSTCENTER'] && !isReportCostCenter"
          class="filters-item filters-item__border"
        >
          <MenuItemAutoComplete
            type="costCenter"
            :status="status"
            @change="updateFilters"
          />
        </div>

        <div
          v-show="claims.project['ROLE_GET_PROJECT'] && !isReportCostCenter"
          class="filters-item filters-item__border"
        >
          <MenuItemAutoComplete
            type="project"
            :status="status"
            @change="updateFilters"
          />
        </div>

        <div
          v-show="isReportRides"
          class="filters-item filters-item__border"
        >
          <MenuItemCategories
            type="category"
            :status="status"
            @change="updateFilters"
          />
        </div>

        <div
          v-show="claims.employee['ROLE_GET_EMPLOYEE'] && !isReportCostCenter"
          class="filters-item filters-item__border"
        >
          <MenuItemAutoComplete
            type="supervisor"
            :status="status"
            @change="updateFilters"
          />
        </div>

        <div
          v-show="claims.employee['ROLE_GET_EMPLOYEE'] && isReportRides"
          class="filters-item filters-item__border"
        >
          <MenuItemAutoComplete
            type="employee"
            :status="status"
            @change="updateFilters"
          />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import debounce from 'lodash.debounce'
import { mapState } from 'vuex'
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'
import MenuItemAutoComplete from 'components/reports/MenuItemAutoComplete'
import MenuItemPeriod from 'components/menuItemPeriod'
import MenuItemCategories from 'components/reports/MenuItemCategories'

export default {
  name: 'Filters',
  props: {
    status: {
      type: Number,
      default: STATUS_IS_LOADING
    },
    activeTab: {
      type: Number,
      default: 0
    },
    routeType: String
  },
  components: {
    MenuItemAutoComplete,
    MenuItemPeriod,
    MenuItemCategories
  },
  computed: {
    ...mapState({
      claims: ({ userClaims }) => userClaims.claims
    }),

    isLoading () {
      return this.status === STATUS_IS_LOADING
    },

    isSuccess () {
      return this.status === STATUS_SUCCESS
    },

    isFailed () {
      return this.status === STATUS_FAILED
    },

    isReportRides () {
      return this.routeType === 'rides'
    },

    isReportCostCenter () {
      return this.routeType === 'costCenter'
    },

    isReportEmployee () {
      return this.routeType === 'employee'
    },

    searchPlaceholder () {
      const placeholders = {
        rides: this.$t(`${this.namespace}.searchRidesPlaceholder`),
        costCenter: this.$t(`${this.namespace}.searchCostCenterPlaceholder`),
        employee: this.$t(`${this.namespace}.searchEmployeePlaceholder`)
      }

      return placeholders[this.routeType]
    },

    searchIsLoading () {
      return this.isLoading && Boolean(this.filters.search)
    }
  },
  data () {
    return {
      namespace: 'Views.ReportsPage',
      filters: {},
      filtersContainer: true
    }
  },
  methods: {
    emitEvent () {
      this.$emit('change', this.filters)
    },

    handleSearch: debounce(function () {
      this.emitEvent()
    }, 1000),

    updateFilters (val) {
      this.filters = {
        ...this.filters,
        ...val
      }

      this.emitEvent()
    },

    changePeriod (period) {
      this.$emit('changePeriod', period)
    },

    resetFilters () {
      this.filtersContainer = false
      setTimeout(() => { this.filtersContainer = true }, 100)
      this.$emit('changePeriod', 'currentMonth')
      this.filters = {}
      this.emitEvent()
    }
  },
  watch: {
    activeTab (val) {
      this.resetFilters()
    }
  }
}
</script>

<style lang="scss" scoped>
.filters { min-height: 69px }
</style>
